<template>
    <div v-if="ad" class="sponsor-ad">
        <span class="sponsor-ad__label">Sponsored by</span>
        <advertisement-placement placement="sponsor" />
    </div>
</template>

<script>
import AdvertisementPlacement from "@/components/App/advertisement-placement.vue";

export default {
    name: "sponsor-ad",
    components: { AdvertisementPlacement },
    computed: {
        ad() {
            return this.$store.state.advertisements.sponsor || null;
        },
    },
};
</script>

<style lang="scss" scoped>
.sponsor-ad {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 20;
    text-align: center;

    @media (min-width: 800px) {
        right: 70px;
    }

    &__label {
        display: block;
        font-size: 12px;
        color: white;
        margin-bottom: 4px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
    }
}
</style>
